import { lazy } from 'react';
// TODO move lazy one level up
export const communityTypeRootScreen = lazy(() => import('./community-type-root-screen/community-type-root-screen'));
